import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { Text } from '../../display/Text/Text.es.js';
import { useInteractiveTagContext } from './InteractiveTagContext.es.js';

const root = "_root_1co9n_1";
const styles = {
	root: root
};

const InteractiveTagContent = ({ body, title }) => {
  const contentRef = useRef(null);
  const { setBody, setIsTruncated, setTitle } = useInteractiveTagContext();
  const checkIsTruncated = () => {
    if (contentRef.current) {
      return contentRef.current.scrollWidth > contentRef.current.clientWidth;
    }
    return false;
  };
  useEffect(() => {
    setIsTruncated(checkIsTruncated());
    setBody(body);
    setTitle(title);
  }, []);
  return jsxs("div", { className: styles.root, ref: contentRef, "data-zds": true, children: [jsxs(Text, { color: "inherit", type: "Body3", children: [title, body ? ": " : ""] }), body && jsx(Text, { color: "inherit", type: "Body1", children: body })] });
};

export { InteractiveTagContent };
//# sourceMappingURL=InteractiveTagContent.es.js.map
